import { css } from 'styled-components'

export const DEFAULT_FONT = css`
  font-family: 'Open Sans Variable', Helvetica, Arial, sans-serif;
`
